module.exports = __webpack_public_path__ + "static/media/6-6.072b1f17.mp3";